export default __webpack_public_path__ + "static/media/8.ddd81e44.gif";